export default __webpack_public_path__ + "static/media/isDocNotUploaded.759c2b54.svg";